import fetchGrapQl from "./fetchGraphQl";

export const getBinanceUsers = (userId: string) => {
  return fetchGrapQl(
    `
      query queryKeyValue{
        settings(where: {name: {_like: "binance%" }}) {
          id
          name
        }
      }
    `,
    "queryKeyValue",
    userId
  );
};

export const addBinanceUser = (userId: string, value: string) => {
  return fetchGrapQl(
    `
      mutation updateBinanceDetails {
        update_settings(where: {}, _set: {binance_details: "${value}"}) {
          affected_rows
        }
      }
    `,
    "updateBinanceDetails",
    userId
  );
};

// Not working for ordinary users atm
export const updateBinanceUser = (
  userId: string,
  id: string,
  name: string,
  value: string
) => {
  return fetchGrapQl(
    `
      mutation updateKeyValue{
        update_settings(where: {id: {_eq: ${id}}}, _set: {name: "binance:${name}", value: "${value}"}) {
          affected_rows
          returning {
            id
            name
          }
        }
      }
    `,
    "updateKeyValue",
    userId
  );
};
